import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=441cfaf2&lang=pug&"
import script from "./Dashboard.vue?vue&type=script&lang=babel&"
export * from "./Dashboard.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Dashboard.vue"
export default component.exports